import { render, staticRenderFns } from "./ManageFaqs.vue?vue&type=template&id=3b51ee4c&scoped=true&"
import script from "./ManageFaqs.vue?vue&type=script&lang=js&"
export * from "./ManageFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51ee4c",
  null
  
)

export default component.exports